import script from "./OperationButtons.vue?vue&type=script&setup=true&lang=js"
export * from "./OperationButtons.vue?vue&type=script&setup=true&lang=js"

import "./OperationButtons.vue?vue&type=style&index=0&id=558e582f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-558e582f"]])

export default __exports__